export default __webpack_public_path__ + "static/media/use_action_back_xw.ec0d0b09.png";